import React from "react"
import "./FilterButton.scss"

function FilterButton(props) {
  return (
    <button
      className={`FilterButton button-filter ${props.active ? 'active' : ''}`}
      type="button"
      onClick={props.onClick}
    >
      {props.text}
    </button>
  );
}

export default FilterButton
